import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';
import { L as LayerType } from '../../common-94559169.js';
import '../../configs/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isCropGroupLayer = function isCropGroupLayer(layer) {
  return layer.type === LayerType.GROUP_LAYER;
};

var isTextLayer = function isTextLayer(layer) {
  return layer.type === LayerType.TEXT_LAYER;
};

var getCropGroupLayerSize = function getCropGroupLayerSize(layer) {
  var clip = layer.clip;

  var _ref = clip || {},
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 0 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height;

  return {
    width: width,
    height: height
  };
};

var getResetLayerAttrs = function getResetLayerAttrs(layer) {
  var x = layer.x,
      y = layer.y,
      width = layer.width,
      height = layer.height,
      scaleX = layer.scaleX,
      scaleY = layer.scaleY,
      rotation = layer.rotation,
      opacity = layer.opacity;
  return _objectSpread(_objectSpread({
    x: x,
    y: y,
    width: width,
    height: height,
    scaleX: scaleX,
    scaleY: scaleY,
    rotation: rotation,
    opacity: opacity,
    offsetX: 0,
    offsetY: 0
  }, isTextLayer(layer) && {
    text: layer.text,
    textArr: layer.textArr,
    height: undefined
  }), isCropGroupLayer(layer) && getCropGroupLayerSize(layer));
};

export { getResetLayerAttrs as default, getResetLayerAttrs };
